// extracted by mini-css-extract-plugin
export var centerText = "_5j-8";
export var container = "_5j-0";
export var doughnutContainer = "_5j-7";
export var legend = "_5j-a";
export var legendItemColorDisplay = "_5j-b";
export var legendItemLabel = "_5j-d";
export var legendItemValue = "_5j-c";
export var lg = "_5j-5";
export var maxWidth = "_5j-9";
export var md = "_5j-4";
export var responsive = "_5j-6";
export var sm = "_5j-3";
export var xs = "_5j-2";
export var xxs = "_5j-1";